import React from "react";
import usePagination from '../../common/table/Pagination';
import { Box, Button, Container, DialogActions, Grid, IconButton, Paper, Stack, Typography, styled, Select, MenuItem, FormControl } from '@mui/material';
import { Table } from "antd"
import Search from '../../common/search';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { fetchChildAccountsListApiCall } from "./Action";
import { Formik, Form as FormikForm } from "formik";
import { TextField } from "../../common/form/input";
import { Label } from "../../common/form/TextInput";
import Modal from "../../common/model";
import { ROUTER_NAME } from "../../router/routers";
import { childAccountSchema } from "../../schema/vendorSchema";
import CountryCodes from '../../helper/countryCodes.json'
import PhoneInput from "../../common/form/PhoneInput";
import { Circle as CircleIcon, Delete as DeleteIcon, ArrowForwardIos as ArrowForwardIosIcon, Delete } from '@mui/icons-material';
import { convertPxToRem, translate } from "../../helper";
import LocalStorage from "../../defined/localStorage";
import ConfirmDialog from "../../common/confirm-modal/ConfirmDialog";
import { deleteChildAccountApiCall } from "../child-accounts-detail/Action";
import TextBase from "../../common/text";
import { Colors } from "../../themes/Colors";
import PageTitleHeader from "../../common/page-title-header";

const brand = JSON.parse(LocalStorage.getItem('branding'))

const PageBox = styled('div')(({ }) => ({
    backgroundColor: '#f9f9f9',
    height: 'calc(10vh)',
    overflowY: 'auto',
    paddingTop: 'calc(var(--sp-md2) * 1.415094)',

    '& .MuiContainer-root': {
        'maxWidth': '100% !important'
    },

    '& .MuiOutlinedInput-input': {
        'padding': 'var(--sp-md2) calc(var(--sp-md2) * 1.32075) !important',
    },

    '& .delete': {
        background: 'white',
        borderRadius: 'calc(var(--sp-lg) * 2.35849)',
        padding: 'var(--sp-xs)',
        fontSize: 'calc(var(--fs-xl) * 1.4150943)',
        boxShadow: '-2px 6px 12px -7px #000',
        color: 'red'
    }
}));
export const CreateaccountButton = styled('div')(({ }) => {
    const whiteLabel = useSelector((state) => state.User?.branding);
    return ({
        'background': `linear-gradient(222.6deg, ${whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218'} 0%, ${whiteLabel?.web_button_color || brand?.web_button_color || '#F8B218'} 100%)`,
        'borderRadius': 'var(--sp-xs)',
        'boxShadow': '0px 4px 4px 0px #B9830917',
        'boxShadow': '0px 4px 10px 0px #B9830940',
        'color': 'white',
        'padding': 'var(--sp-md2) calc(var(--sp-md2) * 2)',
        'marginLeft': 'var(--sp-md2)',
        'textTransform': 'uppercase',
        'cursor': 'pointer',
        'fontWeight': '700',
        'fontSize': 'var(--fs-md2)'
    })
});

const LargeCreateButtonStyled = styled(Button)(({ buttonColor }) => ({
  '&&': {
    background: `linear-gradient(222.6deg, ${buttonColor} 0%, ${buttonColor} 100%)`,
    color: '#FFFFFF !important',
    borderRadius: 'var(--sp-md2)',
    boxShadow: '0px 4px 10px 0px #B9830940',
    padding: '0 calc(var(--fs-xl)*2.35)',
    marginLeft: 'var(--sp-md2)',
    fontWeight: '700',
    fontSize: 'var(--fs-md2)',
    border: '0 !important',
    outline: 'none',
    height: 'calc(var(--fs-xl)*2.35)',

    '&:hover': {
      color: '#FFFFFF !important'
    }
  }
}));

export const LargeCreateButton = (props) => {
  const whiteLabel = useSelector((state) => state.User?.branding);

  const buttonColor =
    brand?.web_button_color ||
    whiteLabel?.web_button_color ||
    '#F8B218';

  return (
    <LargeCreateButtonStyled
      {...props}
      buttonColor={buttonColor}
    />
  );
};

const ActionButton = styled(Button)(({ }) => ({
    'background': '#F3F4F6',
    'color': '#6B7280 !important',
    'fontWeight': '400 !important',
    'textTransform': 'capitalize',
    '& .icon': {
        'fontSize': 'calc(var(--fs-xs) * 1.32075)',
        'color': '#6B7280',
        'marginLeft': 'var(--sp-md2)'
    }
}));

const ChildAccountsPage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { data, loading, total } = useSelector(props => props.childAccountsList_vendor);
    const whiteLabel = useSelector((state) => state.User?.branding);
    const [openDeleteLocation, setOpenDeleteLocation] = React.useState(false);
    const [deleteLocationId, setDeleteLocationId] = React.useState(null);

    const [filters, setFilters] = React.useState({
        pageNo: 1,
        limit: 15,
        searchKey: '',
        ordering: '-created_at',
    });
    const [openCreateChildAccounts, setOpenCreateChildAccounts] = React.useState(false);

    const [paging] = usePagination(total, filters, setFilters);

    React.useEffect(() => {
        document.title = 'Location';
    }, []);

    React.useEffect(() => {
        fetchChildAccountsListApiCall(filters, dispatch);
    }, [filters]);

    const handleTeamDelete = () => {
        deleteChildAccountApiCall(deleteLocationId, () => {
            fetchChildAccountsListApiCall(filters, dispatch);
            setOpenDeleteLocation(false);
        });
    }

    const locationColumns = [
        {
            title: translate('location'),
            dataIndex: 'location',
            align: 'left',
            key: 'location',
            render: (__, row) => {
                return (
                    row.location_name || ''
                )
            }
        },
        {
            title: translate('locationAddress'),
            dataIndex: 'location_address',
            align: 'left',
            key: 'id',
            render: (__, row) => {
                return row.location || ''
            }
        },
        {
            title: translate('phoneNumber'),
            dataIndex: 'phone_number',
            align: 'left',
            key: 'phone_number',
            render: (__, row) => {
                return row.mobile_number?.replace('-', '') || '';
            }
        },
        {
            title: translate('admin1Name'),
            dataIndex: 'admin1_name',
            align: 'left',
            key: 'name',
            render: (__, row) => {
                return row.admin_name_1 || ''
            }
        },
        {
            title: translate('admin1Email'),
            dataIndex: 'admin1_email',
            align: 'left',
            key: 'email',
            render: (__, row) => {
                return row.admin_email_1 || ''
            }
        },
        {
            title: translate('status'),
            dataIndex: 'status',
            align: 'left',
            key: 'status',
            render: (__, row) => {
                return row.status.toLowerCase() === 'active' ? (
                    <CircleIcon
                        sx={{ color: '#00B81D' }}
                    />
                ) : (
                    <CircleIcon
                        sx={{ color: '#FB0505' }}
                    />
                )
            }
        },
        {
            title: '',
            dataIndex: 'setting',
            align: 'left',
            key: 'setting',
            onCell: (__, row) => {
                return {
                    onClick: event => {
                        event.stopPropagation(); // this will avoid onRow being called
                    }
                }
            },
            render: (__, row) => {
                return (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <ActionButton
                            onClick={() => {
                                navigate(`${ROUTER_NAME.childAccounts}/${row.id}`, {
                                    state: row
                                });
                            }}
                        >
                            {translate('manage')}
                            <ArrowForwardIosIcon className='icon' />
                        </ActionButton>
                        <IconButton
                            onClick={() => {
                                setDeleteLocationId(row.id);
                                setOpenDeleteLocation(true);
                            }}
                        >
                            <DeleteIcon className='delete' />
                        </IconButton>
                    </div>
                )
            }
        },
    ]

    return (
        <PageBox style={{ backgroundColor: "#fff" }}>
            <Container>

                <CreateModalChildAccounts
                    isOpen={openCreateChildAccounts}
                    onClose={() => setOpenCreateChildAccounts(false)}
                    refetch={() => {
                        setOpenCreateChildAccounts(false);
                        fetchChildAccountsListApiCall(filters, dispatch);
                    }}
                />

                <ConfirmDialog
                    isOpen={openDeleteLocation}
                    onClose={() => setOpenDeleteLocation(false)}
                    title='deleteLocation'
                    description='deleteConfirmText'
                    onOk={handleTeamDelete}
                />

                <PageTitleHeader title={translate('locations')} />
                <Stack marginY={'20px'} alignItems={'center'} justifyContent={'space-between'} direction="row" spacing={2}>
                    <Box>
                        <Search
                            placeholder={translate('searchLocation')}
                            setQuery={(value) => {
                                setFilters({
                                    ...filters,
                                    pageNo: 1,
                                    searchKey: value
                                });
                            }}
                        />
                    </Box>
                    <Box display={'flex'} alignItems={'cenetr'}>
                        <CreateaccountButton onClick={() => navigate(`${ROUTER_NAME.childAccounts}/new`)}>
                            {translate('createNewLocation')}
                        </CreateaccountButton>
                    </Box>
                </Stack>
                <Table
                    style={{ width: '100%', padding: "20px" }}
                    columns={locationColumns}
                    dataSource={data}
                    className="table"
                    bordered={false}
                    loading={loading}
                    total={total}
                    pagination={false}
                    onRow={(row, __) => {
                        return {
                            onClick: event => {
                                navigate(`${ROUTER_NAME.childAccounts}/${row.id}`, {
                                    state: row
                                });
                            },
                        };
                    }}
                />
                {paging}
            </Container>

        </PageBox>
    );

}

const FormActionButton = styled(Button)(({ theme }) => ({
    'background': 'linear-gradient(222.6deg, #F8B218 0%, #F8B218 100%)',
    'borderRadius': '5px',
    'width': '100%',
    'boxShadow': '0px 4px 4px 0px #B9830917',
    'boxShadow': '0px 4px 10px 0px #B9830940',
    'color': 'white',
}));

const CreateChildAccountsWrapper = styled('div')(({ }) => ({
    '& .MuiSelect-select': {
        'padding': '15px 10px',
        'backgroundColor': '#F8F8F8',
    },
}))

const CreateModalChildAccounts = ({ isOpen, onClose }) => {

    const handleSubmit = () => {
    }

    return (
        <Modal
            title={'createLocation'}
            isOpen={isOpen}
            onClose={onClose}
        >
            <CreateChildAccountsWrapper>
                <Formik
                    initialValues={{
                        account_name: 'Child Account',
                        first_name: '',
                        last_name: '',
                        email: '',
                        mobile_number: '',
                        country_code: '',
                        location: '',
                        custom_domain: false,
                        manage_branding: false,
                    }}
                    validationSchema={childAccountSchema}
                    onSubmit={handleSubmit}
                >
                    {({ values, errors, touched, handleChange }) => (
                        <FormikForm>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <TextField
                                        label={translate('locationName')}
                                        value={values.first_name}
                                        type='text'
                                        id='first_name'
                                        name='first_name'
                                        error={Boolean(touched.first_name && errors.first_name)}
                                        helperText={touched.first_name && errors.first_name}
                                        fullWidth
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        label={translate('locationAddress')}
                                        value={values.last_name}
                                        type='text'
                                        id='last_name'
                                        name='last_name'
                                        error={Boolean(touched.last_name && errors.last_name)}
                                        helperText={touched.last_name && errors.last_name}
                                        fullWidth
                                        asTextArea
                                        minRows={3}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Label htmlFor={'mobile_number'}>{translate('locationPhoneNumber')}</Label>
                                    <Grid container spacing={1}>
                                        <Grid item xs={5}>
                                            <FormControl fullWidth>
                                                <Select
                                                    displayEmpty
                                                    onChange={handleChange}
                                                    value={values.country_code}
                                                    id='country_code'
                                                    name='country_code'
                                                    error={Boolean(touched.country_code && errors?.country_code)}
                                                    renderValue={
                                                        values.country_code !== ''
                                                            ? () => {
                                                                const { code, dial_code } = CountryCodes.find(cc => cc.dial_code == values.country_code)
                                                                return (
                                                                    <span>{code + ' ' + dial_code}</span>
                                                                )
                                                            }
                                                            : () => <span style={{ color: '#ababab' }}>{ }</span>
                                                    }
                                                >
                                                    {
                                                        CountryCodes.map((option, index) => (
                                                            <MenuItem value={option.dial_code}>{option.name + ' ' + option.dial_code}</MenuItem>
                                                        ))
                                                    }
                                                </Select>
                                                {Boolean(touched.country_code && errors.country_code) ? (
                                                    <Typography variant="caption" color="error" style={{ textAlign: 'left' }}>
                                                        {errors.country_code}
                                                    </Typography>
                                                ) : (
                                                    ''
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={7}>
                                            <TextField
                                                value={values.mobile_number}
                                                type='text'
                                                id='mobile_number'
                                                name='mobile_number'
                                                error={Boolean(touched.mobile_number && errors.mobile_number)}
                                                helperText={touched.mobile_number && errors.mobile_number}
                                                fullWidth
                                                InputProps={{
                                                    inputComponent: PhoneInput,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid xs={12}>
                                    <DialogActions>
                                        <FormActionButton type='submit'>{translate('save')}</FormActionButton>
                                    </DialogActions>
                                </Grid>
                            </Grid>
                        </FormikForm>
                    )}

                </Formik>
            </CreateChildAccountsWrapper>
        </Modal>
    )

}

export default ChildAccountsPage;